import { FetchRequest } from "@rails/request.js"
import ServerTableController from "./server_table_base"

export default class extends ServerTableController {
  activeCategoryFilters = ""
  completionFilter = ""

  get filterWrapperName() { return "action-items-filter" }
  get checkboxPrefix() { return "action-items" }

  // Rows are rendered server-side (action_items/_action_item_row): [sort_date, html].
  get columns() {
    return [
      { data: "0", visible: false },
      { data: "1" }
    ]
  }

  applyFilters(detail) {
    this.activeCategoryFilters = detail.categoryFilters || ""
    this.completionFilter = detail.completion || ""
  }

  ajaxData(d) {
    super.ajaxData(d)
    d.category_filters = this.activeCategoryFilters
    d.completion = this.completionFilter
    return d
  }

  createdRow(row, data, _dataIndex) {
    $(row).addClass("item").html(data[1])
  }

  async toggleCompletion(event) {
    event.preventDefault()
    event.stopPropagation()

    const target = event.currentTarget
    const id = target.dataset.id
    const isDone = target.dataset.done === "true"
    const actionStudentId = target.dataset.studentId
    const actionClassroomId = target.dataset.classroomId

    const url = actionClassroomId
      ? `/classrooms/${actionClassroomId}/actions/${id}/completion`
      : `/students/${actionStudentId}/actions/${id}/completion`
    const method = isDone ? "delete" : "patch"

    const request = new FetchRequest(method, url, {})
    const response = await request.perform()

    if (response.ok) {
      const newDone = !isDone
      const row = target.closest("tr")

      row.querySelectorAll(".completion-toggle").forEach(toggle => {
        toggle.dataset.done = newDone
        const toggleIcon = toggle.querySelector(".o-toggle-icon")
        if (toggleIcon) {
          toggleIcon.classList.toggle("is-checked", newDone)
        }
      })

      row.querySelectorAll("td.o-list-card").forEach(card => {
        card.classList.remove("o-list-card--force", "o-list-card--neutre", "o-list-card--difficulte")
        card.classList.add(newDone ? "o-list-card--force" : "o-list-card--neutre")
      })

      this.updateActionCounters(newDone ? 1 : -1)
    }
  }

  updateActionCounters(delta) {
    const doneEl = document.querySelector("[data-action-items-done-count]")
    const pendingEl = document.querySelector("[data-action-items-pending-count]")
    if (!doneEl || !pendingEl) return

    const currentDone = parseInt(doneEl.textContent) || 0
    const currentPending = parseInt(pendingEl.textContent) || 0
    const newDone = currentDone + delta
    const newPending = currentPending - delta

    const doneLabel = newDone <= 1 ? doneEl.dataset.doneOne : doneEl.dataset.doneOther
    const pendingLabel = newPending <= 1 ? pendingEl.dataset.pendingOne : pendingEl.dataset.pendingOther

    doneEl.textContent = `${newDone} ${doneLabel}`
    pendingEl.textContent = `${newPending} ${pendingLabel}`
  }
}
